import React, { useState, useEffect } from 'react';
import './Hero.css';
import './HeroMobile.css';

import heroImage from '../../media/hero_ver_0-transformed.png';
import { useLanguage } from '../switchLang/useLang';

const HeroCharacter = () => {
    const [showText, setShowText] = useState(false);
    const { t, lang } = useLanguage(); // Получаем функцию переключения и текущий язык

    const [isActive, setIsActive] = useState(false);

    useEffect(() => {
        // Таймер для запуска анимации через секунду после открытия
        const timer = setTimeout(() => {
            setIsActive(true);
        }, 1500); // Задержка перед запуском
        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        const timer = setTimeout(() => {
            setShowText(true);
        }, 3000); // Задержка перед показом текста

        return () => clearTimeout(timer);
    }, []);

    return (
        <div className={`hero-container ${isActive ? 'active' : ''}`}>
            <img src={heroImage} alt="Hero Character" />
            {showText && (
                <div
                    className="text-bubble"
                    onClick={() => {
                        const url =
                            lang === 'en'
                                ? "https://discord.gg/29R2g3wb78"
                                : "https://vk.com/siliconeheart";
                        window.open(url, "_blank", "noopener,noreferrer");
                    }}
                    style={{ cursor: "pointer" }}
                >
                    <a
                        className="group-link"
                    >
                        <p>{t("helloSlogan")}</p>

                    </a>
                </div>
            )}
        </div>
    );
};

export default HeroCharacter;
